import React from "react"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import {Col} from "@irati/ui/src/Layout"
import PropTypes from "prop-types"
import {Label} from "@irati/ui/src/Typography"
import theme from "@irati/ui/src/global/theme"

import {Row, RowStart, RowMiddle, RowEnd} from "../../Row"

const UserHeader = ({header, formatMessage}) => {
  return (
    <Row>
      <RowStart />
      <RowMiddle>
        <Col md={4} xs={6}>
          <Label color={theme.colors.greys.mediumDark} uppercase>
            <FormattedMessage id="admin.components.userHeader.smallCaption.text" />
          </Label>
        </Col>
        {header && (
          <Col md={8} xs={6}>
            <Label color={theme.colors.greys.mediumDark} uppercase>
              {formatMessage({id: header})}
            </Label>
          </Col>
        )}
      </RowMiddle>
      <RowEnd />
    </Row>
  )
}

UserHeader.defaultProps = {
  header: "admin.components.userHeader.smallCaption.teams"
}

UserHeader.propTypes = {
  header: PropTypes.string,
  formatMessage: PropTypes.func.isRequired
}

export default injectIntl(UserHeader)
